import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController, IonInput } from '@ionic/angular/lazy';
import { CartService } from 'src/app/services/cart.service';
import { DonationCampaignService } from 'src/app/services/donation-campaign.service';
import { Decimal } from 'decimal.js';

@Component({
    selector: 'app-sell-donation',
    templateUrl: './sell-donation.page.html',
    styleUrls: ['./sell-donation.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SellDonationPage implements OnInit {

    @ViewChild('amount_input', { static: false }) amount_input: IonInput;

    donation_campaigns = null;
    donation_campaign_id = null;
    amount = null;
    spinner = null;
    adding_to_cart = false;

    selectOptions: any = {
        cssClass: 'wide-select'
    };

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private cartService: CartService,
        private donationCampaignService: DonationCampaignService
    ) { }

    ngOnInit() {

        this.donationCampaignService.getDonationCampaigns({}).then((donation_campaigns: any) => {
            if(donation_campaigns) {
                this.donation_campaigns = donation_campaigns;
                this.donation_campaign_id = donation_campaigns[0].id;
            }
        })
        .catch(() => { });

    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        if(this.donation_campaigns && this.donation_campaigns.length == 1) {
            setTimeout(() => {
                if(this.amount_input) {
                    this.amount_input.setFocus();
                }
            }, 200);
        }
    }

    close() {
        this.modalController.dismiss();
    }

    addToCart() {

        let donation_campaign = null;

        for (let i = 0; i < this.donation_campaigns.length; i++) {
            if(this.donation_campaigns[i].id == this.donation_campaign_id) {
                donation_campaign = this.donation_campaigns[i];
            }
        }

        this.cartService.addDonationItem(donation_campaign,this.amount).then(() => {
            this.modalController.dismiss();
        })
        .catch(() => {
            this.adding_to_cart = false;
        });

    }

    validateInput() {

        // NOTE: ignore repeat presses while the donation is being validated/added, otherwise a double tap/Enter adds it twice
        if(!this.adding_to_cart) {

            this.adding_to_cart = true;

            let validated = true;
            this.presentSpinner("Validating donation").then(async () => {

                let price_regex = /^\d+(\.\d+)?$/;

                // Catch nulls
                if (this.amount == null || this.amount.trim() === "") {
                    validated = false;
                    this.spinner.dismiss();
                    this.presentAlert("No amount entered", "");
                }
                // Catch letters or symbols or multiple dps
                else if (!price_regex.test(String(this.amount).toLowerCase())) {
                    validated = false;
                    this.spinner.dismiss();
                    this.presentAlert("Invalid amount", "");
                }
                else {
                    // ensure 2dp
                    this.amount = Number(new Decimal(this.amount).toDecimalPlaces(2));
                }

                if (validated) {
                    this.spinner.dismiss();
                    this.addToCart();
                }
                else {
                    this.spinner.dismiss();
                    this.adding_to_cart = false;
                }
            });

        }

    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
